import { configureStore } from "@reduxjs/toolkit";
import sessionReducer from "../slices/sessionSlice";
import productReducer from "../slices/productSlice";
import authReducer from "../slices/authSlice";
import blogReducer from "../slices/blogSlice";
const store = configureStore({
  reducer: {
    session: sessionReducer,
    product: productReducer,
    auth: authReducer,
    blog: blogReducer,
  },
});

export default store;
